export default __webpack_public_path__ + "static/media/editIcon.41e62d45.svg";